import { createRouter, createMemoryHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 1. 사업안내
  {
    path: '/overview',
    name: 'overview',
    component: () => import('../views/business/BusinessView.vue')
  },
  {
    path: '/location',
    name: 'location',
    component: () => import('../views/premium/PremiumView.vue')
  },
  {
    path: '/directions',
    name: 'directions',
    component: () => import('../views/sale/SaleView.vue')
  },
  // 2. 단지안내
  {
    path: '/premium',
    name: 'premium',
    component: () => import('../views/complex/ComplexView.vue')
  },
  {
    path: '/community',
    name: 'community',
    component: () => import('../views/complex/CommunityView.vue')
  },
  {
    path: '/site-plan',
    name: 'site-plan',
    component: () => import('../views/complex/SitePlanView.vue')
  },
  {
    path: '/unit-plan',
    name: 'unit-plan',
    component: () => import('../views/complex/UnitPlanView.vue')
  },
  // 3. 세대안내
  {
    path: '/household/59a',
    name: 'household-59a',
    component: () => import('../views/household/Household59AView.vue')
  },
  {
    path: '/household/59b',
    name: 'household-59b',
    component: () => import('../views/household/Household59BView.vue')
  },
  {
    path: '/household/84a',
    name: 'household-84a',
    component: () => import('../views/household/Household84AView.vue')
  },
  {
    path: '/household/84b',
    name: 'household-84b',
    component: () => import('../views/household/Household84BView.vue')
  },
  // 4. 방문예약하기
  {
    path: '/reservation',
    name: 'reservation',
    component: () => import('../views/support/SupportView.vue')
  },
  // 관리자 페이지
  {
    path: '/adminblooming',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createMemoryHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.isReady().then(() => {
  if (window.location.hash === '#/adminblooming') {
    router.push('/adminblooming')
  }
})

export default router
